
import { defineComponent } from "vue";
import LandingPageLoginForm from "../../features/landing-page-login-form.vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";

export default defineComponent({
  components: { LandingPageLoginForm, BaseTypography },
  props: {
    showQuote: {
      type: Boolean,
      default: true,
    },
    version: {
      type: String,
      default: "",
    },
  },
});
